import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';

import { FilterOption, FilterSelect } from '@warrenbrasil/nebraska-web';

import { EOrdersType } from './types';
import {
  IFilter,
  IFilterOption
} from '@/modules/wealth/services/portfolio-orders';

interface Props {
  disabled?: boolean;
  filters?: IFilter[];
  periodOptions?: IFilterOption[];
  selectedTab?: EOrdersType;
  openedOrdersCount?: number;
  clearFilters?: boolean;
}

interface Emits {
  (event: 'change-tab', value: EOrdersType): void;
  (
    event: 'change-filter',
    value: Record<string, string[] | string>,
    hasFilters: boolean
  ): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Filters',
  props: {
    disabled: { type: Boolean, default: false },
    filters: { default: () => [] },
    periodOptions: { default: () => [] },
    selectedTab: { default: EOrdersType.CONCLUDED },
    openedOrdersCount: { default: 0 },
    clearFilters: { type: Boolean, default: false }
  },
  emits: ["change-tab", "change-filter"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'change-tab', value: EOrdersType): void;
  (
    event: 'change-filter',
    value: Record<string, string[] | string>,
    hasFilters: boolean
  ): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { disabled: boolean, filters: IFilter[], periodOptions: IFilterOption[], selectedTab: EOrdersType, openedOrdersCount: number, clearFilters: boolean };





watch(
  () => props.clearFilters,
  clearFilters => {
    if (clearFilters) {
      selectedType.value = '';
      selectedPeriod.value = '';
      emits('change-filter', { type: [], period: '' }, hasFilters.value);
    }
  },
  { immediate: true }
);

const selectedType = ref('');
const selectedPeriod = ref('');

const ordersOptions = ref([
  {
    label: 'Concluídas',
    value: EOrdersType.CONCLUDED,
    disabled: false,
    counter: null
  },
  {
    label: 'Abertas',
    value: EOrdersType.OPENED,
    disabled: props.openedOrdersCount === 0,
    counter: props.openedOrdersCount
  }
]);

const hasFilters = computed(() => {
  return Boolean(selectedType.value || selectedPeriod.value);
});

function handleTabChange(value: EOrdersType) {
  emits('change-tab', value);
}

function handleFilterChange(type: string, value: string | string[]) {
  emits('change-filter', { [type]: value }, hasFilters.value);
}

return { __sfc: true,props, emits, selectedType, selectedPeriod, ordersOptions, hasFilters, handleTabChange, handleFilterChange, FilterOption, FilterSelect, EOrdersType }
}

})